import * as types from './types'
// setOrderFilterData
/**
 * @function 余额明细筛选条件
 * @param commit
 * @param data
 */
export const setBalanceCondition = ({ commit }, data) => {
  commit(types.SET_BALANCE_CONDITION, data)
}
export const setMapAddressInfo = ({ commit }, data) => {
  commit(types.SET_MAP_ADDRESS_INFO, data)
}
export const setDeliveryVersion = ({ commit }, data) => {
  commit(types.SET_DELIVERY_VERSION, data)
}
